module.exports = "/images/2.webp?b4e43b58e509260de14c69d321c0b64a";